export default __webpack_public_path__ + "static/media/prevArrow.7afce03d.svg";